import { Pipe, PipeTransform } from '@angular/core';

import { HidingGroups, HidingField } from '../interfaces/datatable';

@Pipe({ name: 'getDatatableHidingFields' })
export class GetDatatableHidingFieldsPipe implements PipeTransform {

  /* trasnform(): Pipe que devuelve un array de índices con el valor booleano falso de la estructura HidingGroups del datatable
    value: Configuración de la opción
  */
  transform = (value: HidingGroups): number[] => Object.values(value).map((elm: HidingField) => Object.keys(elm).filter((el: string) => !elm[el]).join("...")).join("...").split("...").filter((elm: string) => elm).map((elm: string) => Number(elm));

}
